import React from 'react';

/* The AR tab's cards in the Job Costs look (JobCostDashboardPage's JobCard): Billing by Phase's
   projects and Statements' customers (Duncan 2026-10-19: "the look and prestige that we are using
   with the rest of the system"). */

export const MicroLabel = ({ children }) => <div style={{ fontSize: 11.5, fontWeight: 700, letterSpacing: '0.05em', textTransform: 'uppercase', color: 'var(--text-3)', whiteSpace: 'nowrap' }}>{children}</div>;

/** A card's column: a small label, the figure, a line under it (always drawn, so the columns line up). */
export const MetricCol = ({ label, value, sub, big, color, subColor }) => (
  <div style={{ display: 'flex', flexDirection: 'column', gap: 6, minWidth: 0, alignItems: 'flex-end' }}>
    <MicroLabel>{label}</MicroLabel>
    <span className="mono" style={{ fontSize: big ? 20 : 15, lineHeight: big ? 1.1 : undefined, fontWeight: 700, color: color || 'var(--text-1)', fontVariantNumeric: 'tabular-nums', letterSpacing: '-0.02em', whiteSpace: 'nowrap' }}>{value}</span>
    <span className="mono" style={{ marginTop: -3, fontSize: 12, color: subColor || 'var(--text-3)', fontVariantNumeric: 'tabular-nums', whiteSpace: 'nowrap' }}>{sub ?? '\u00a0'}</span>
  </div>
);
